const initialState = {
  open: false,
};

export default {
  namespace: 'ticketDrawer',

  state: initialState,

  reducers: {
    openDrawer(state: any) {
      return {
        ...state,
        open: true,
      };
    },
    closeDrawer(state: any) {
      return {
        ...state,
        open: false,
      };
    },
    reset() {
      return initialState;
    },
  },
};
